import type React from "react";

export interface CategoryTitleProps {
  title: string;
  link: string;
  linkName: string;
  titleEN: string;
  linkClicked: (linkName: string) => void;
}

export const CategoryTitle: React.FC<CategoryTitleProps> = ({
  title,
  link,
  linkName,
  titleEN,
  linkClicked,
}) => (
  <div className="flex h-28 w-calc(100%-16px) flex-col py-4">
    <h2 className="mb-6 font-bold text-xl uppercase">{title || titleEN}</h2>
    {link && (
      <a
        className="font-normal text-nav-hover text-sm"
        href={link}
        onClick={() => linkClicked(linkName)}
      >
        {linkName}
      </a>
    )}
  </div>
);
